<template>
  <div data-component-group="filter-forms" data-component="pins">
    <FiltersForm
        :has-filters="hasFilters"
        @filter="onFilter"
        @clear="onClearFilters"
        v-model="selectedCountries"
    />
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';

  // TODO: Translate component

  export default {
    components: {
      FiltersForm,
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        selectedCountries: [],
      };
    },
    computed: {
      hasFilters() {
        return this.selectedCountries.length > 0;
      },
    },
    methods: {
      onFilter() {
        const {selectedCountries} = this;

        this.$emit('filter', {
          countries: selectedCountries,
        });
      },
      onClearFilters() {
        this.selectedCountries = [];
        this.$emit('clearFilters');
      },
    },
  };
</script>

<style lang="scss">
@use 'sass:map';
@use '../../../assets/styles/theme' as *;

[data-component-group='filter-forms'][data-component='pins'] {
  .v-btn {
    height: auto;
    max-height: initial;
    white-space: normal;
    padding: $spacing-xs;

    .v-btn__content {
      justify-content: flex-start;
    }

    &.active {
      color: map.get($colors, shades, 'white');
      background-color: map.get($colors, grey, base) !important;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
